const ApiUrl_Ciudadano = `${process.env.VUE_APP_API_PP_CIUDADANO}`
const ApiUrl_PortalPartido = `${process.env.VUE_APP_API_PP_PARTIDOS}`
import axios from '@/interceptor-core'

export const requestAfiliacionPPMixin = {
  methods: {
    getCiudadanoVerificarAndRegistro(body) {
      return axios.post(`${ApiUrl_PortalPartido}/afiliacion/manual/verificar`, body);
    },
    enviarAfilicacionManual(body) {
      return axios.post(`${ApiUrl_PortalPartido}/afiliacion/manual`, body);
    },
    findAfiliacionByRutOrName(query) {
      const body = {
        search: query
      }
      return axios.post(`${ApiUrl_PortalPartido}/afiliacion/ficha/buscar`, body)
    }
  }
};
